import { Product } from '../types/product';
import { images } from './images';

export const products: Product[] = [
  {
    slug: 'paper-core',
    name: 'Paper Core',
    category: 'Manufactured',
    manufactured: true,
    line: 'Custom cores for every winding job',
    text: 'We make paper cores in Umm Al Quwain, sized to the material you wind and the equipment you run. Cores are the centre support of a roll and matter in winding, handling, storage and transport. Used for film rolls, stretch film, paper and board, printing and converting.',
    variants: ['Custom sizes'],
    sendUs: ['Inner diameter', 'Wall thickness', 'Length', 'Quantity', 'Application'],
    image: images.paperCores,
  },
  {
    slug: 'stretch-films',
    name: 'Stretch Films',
    category: 'Manufactured',
    manufactured: true,
    line: 'Pallet wrap in hand, machine and power grades',
    text: 'Our stretch film clings to itself under tension and holds loads together through storage and transport. Clear film keeps labels readable and keeps out dust and moisture. Used for pallets, furniture and mixed shape loads.',
    variants: ['Hand grade', 'Mini rolls', 'Machine grade', 'Power grade, 200 to 400% prestretch'],
    sendUs: ['Grade', 'Width', 'Thickness', 'Roll length', 'Core size', 'Quantity'],
    image: images.stretchFilm,
  },
  {
    slug: 'fluting-paper',
    name: 'Fluting Paper',
    category: 'Paper',
    manufactured: false,
    line: 'The middle layer of corrugated board',
    text: 'Fluting paper forms the wavy layer inside corrugated board and gives boxes structure and cushioning. We source it to your production requirements for board makers and packaging businesses. Used for corrugated board, shipping cartons and protective packaging.',
    variants: ['By grade and GSM'],
    sendUs: ['Grade', 'GSM', 'Roll width', 'Roll diameter', 'Quantity', 'Delivery location'],
    image: images.flutingPaper,
  },
  {
    slug: 'pof-shrink-film',
    name: 'Polyolefin Shrink Film, POF',
    category: 'Films',
    manufactured: false,
    line: 'Clear shrink film for retail ready packs',
    text: 'POF shrinks tight around the product when heated, giving a clear, tamper evident wrap that protects against dust and moisture. Suits products of mixed shapes and sizes where presentation matters.',
    variants: ['Plain', 'Printed'],
    sendUs: ['Width', 'Thickness', 'Single or centre fold', 'Quantity'],
    image: images.shrinkFilm,
  },
  {
    slug: 'ldpe-shrink-film',
    name: 'LDPE Shrink Film',
    category: 'Films',
    manufactured: false,
    line: 'Heavy duty shrink wrap for bulk and multipacks',
    text: 'LDPE shrink film tightens around goods when heated and holds single items or bundled multipacks firmly. Protects against dust, moisture and tampering.',
    variants: ['Plain', 'Printed'],
    sendUs: ['Width', 'Thickness', 'Pack size', 'Print design if printed', 'Quantity'],
    image: images.ldpeShrink,
  },
  {
    slug: 'laminates',
    name: 'Laminates',
    category: 'Films',
    manufactured: false,
    line: 'Multi layer films for food and product packs',
    text: 'Laminated films bond 2 or more layers into one material, giving strength and a barrier against moisture. Used for pouches and flexible packs.',
    variants: ['Plain', 'Printed', '2 ply', '3 ply', '4 ply'],
    sendUs: ['Structure', 'Width', 'Thickness', 'Print design', 'Quantity'],
    image: images.laminates,
  },
  {
    slug: 'bopp-film',
    name: 'BOPP Film',
    category: 'Films',
    manufactured: false,
    line: 'Clear film for wrapping and lamination',
    text: 'BOPP film gives a clear, smooth layer for wrapping and laminating. Resists moisture and wear while showing the product. Used for food, retail goods and documents.',
    variants: ['Plain', 'Printed'],
    sendUs: ['Width', 'Thickness', 'Finish', 'Quantity'],
    image: images.boppFilm,
  },
  {
    slug: 'thermoforming-film',
    name: 'Thermoforming Film',
    category: 'Films',
    manufactured: false,
    line: 'Forming film for vacuum sealed food packs',
    text: 'Thermoforming film moulds to the product under heat and seals it against air and moisture. Easy peel versions open cleanly by hand. Used for cheese, meat and dates.',
    variants: ['Easy peel'],
    sendUs: ['Forming and lidding web specs', 'Width', 'Thickness', 'Application', 'Quantity'],
    image: images.thermoforming,
  },
  {
    slug: 'vacuum-bags',
    name: 'Vacuum Bags',
    category: 'Films',
    manufactured: false,
    line: 'Airtight bags for food and storage',
    text: 'Vacuum bags remove air and seal airtight, keeping food fresh and goods compact.',
    variants: ['Nylon vacuum', 'Plain vacuum', 'Printed'],
    sendUs: ['Bag size', 'Thickness', 'Print design', 'Quantity'],
    image: images.vacuumBags,
  },
  {
    slug: 'casing-pa-pe',
    name: 'Casing, PA/PE',
    category: 'Films',
    manufactured: false,
    line: 'Barrier casings for sausage and meat',
    text: 'PA/PE casings form a barrier against moisture, odour and contamination for sausages and processed meat. Work on manual and automated lines.',
    variants: ['Plain', 'Printed'],
    sendUs: ['Calibre', 'Length', 'Colour', 'Print design', 'Quantity'],
    image: images.casing,
  },
  {
    slug: 'opp-labels',
    name: 'OPP Labels',
    category: 'Labels and Sleeves',
    manufactured: false,
    line: 'Clear, printed labels for retail packs',
    text: 'OPP labels carry brand and product information with a clean finish that holds up to handling and moisture.',
    variants: ['Printed', 'Metallised'],
    sendUs: ['Label size', 'Design', 'Roll specs', 'Quantity'],
    image: images.oppLabels,
  },
  {
    slug: 'pvc-sleeves',
    name: 'PVC Sleeves',
    category: 'Labels and Sleeves',
    manufactured: false,
    line: 'Shrink sleeves for bottles and containers',
    text: 'PVC sleeves slide over bottles and containers and shrink to fit, protecting against scratches and dust and carrying full wrap branding.',
    variants: ['Plain', 'Printed'],
    sendUs: ['Container size', 'Lay flat width', 'Design', 'Quantity'],
    image: images.pvcSleeves,
  },
  {
    slug: 'strap-and-buckles',
    name: 'Strap and Buckles',
    category: 'End of Line',
    manufactured: false,
    line: 'Strapping to secure loads and bundles',
    text: 'Strapping holds bundles and loads together through handling and transport.',
    variants: ['Cord strap', 'PET strap', 'PP strap', 'Buckles'],
    sendUs: ['Strap type', 'Width', 'Break strength', 'Quantity'],
    image: images.strapping,
  },
  {
    slug: 'caution-tape',
    name: 'Caution Tape',
    category: 'End of Line',
    manufactured: false,
    line: 'Printed warning tape for hazards and sites',
    text: 'Bright printed tape that marks hazards, work zones and restricted areas. Built to stay visible outdoors.',
    variants: ['Printed'],
    sendUs: ['Width', 'Roll length', 'Print text', 'Colour', 'Quantity'],
    image: images.cautionTape,
  },
  {
    slug: 'ldpe-tissue-rolls-pouches',
    name: 'LDPE Tissue, Rolls and Pouches',
    category: 'End of Line',
    manufactured: false,
    line: 'Soft film that protects delicate items',
    text: 'Soft LDPE tissue cushions delicate items against scratches, dust and moisture in storage and transport.',
    variants: ['Printed rolls', 'Printed pouches', 'Plain rolls', 'Plain pouches'],
    sendUs: ['Roll or pouch size', 'Thickness', 'Print design', 'Quantity'],
    image: images.ldpeTissue,
  },
  {
    slug: 'machines',
    name: 'Packaging Machines',
    category: 'Machines',
    manufactured: false,
    line: 'Shrink wrap and sleeve wrapping machines, supplied for your line',
    text: 'We supply shrink wrap and sleeve wrapping machines from trusted makers. Shrink wrap machines wrap and seal products with heat. Sleeve wrapping machines apply sleeves to products automatically. Both handle a range of product sizes and give a consistent finish.',
    variants: [
      'Automatic L bar sealer',
      'Semi automatic L bar sealer with tunnel',
      'Sleeve wrapping machine',
    ],
    sendUs: ['Product size', 'Output per hour', 'Power supply'],
    image: images.shrinkMachine,
  },
];
